import {
  includes as _includes,
  filter as _filter,
  isEmpty as _isEmpty,
} from "lodash-es";
import React, { useState, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { Modal, ModalBody, ModalTitle } from "../../components/Modal";
import Button from "../../components/Button";

import { addHumans, removeHuman, createCircle } from "../../actions/circles";
import { commitHuman } from "../../actions/humans";
import Input from "../../components/Input";

const mapStateToProps = (state) => ({
  circles: state.circles,
});

const mapDispatchToProps = (dispatch) => ({
  addHumans: (humanIds, circleId) => dispatch(addHumans(humanIds, circleId)),
  removeHuman: (humanId, circleId) => dispatch(removeHuman(humanId, circleId)),
  createCircle: (circleName) => dispatch(createCircle(circleName)),
});

const EditHumanCirclesModal = React.memo((props) => {
  const { human, circles, onClosed, addHumans, removeHuman, createCircle } =
    props;

  const [query, setQuery] = useState("");
  const searchInputRef = useRef(null);
  const dispatch = useDispatch();

  const lowercaseQuery = query.toLowerCase();
  const visibleCircles = !query
    ? circles
    : _filter(circles, (c) => _includes(c.name.toLowerCase(), lowercaseQuery));
  visibleCircles.sort((a, b) => a.name.localeCompare(b.name));
  visibleCircles.sort(
    (a, b) => _includes(b.humanIds, human.id) - _includes(a.humanIds, human.id)
  );

  const onAdd = (circleId) => {
    dispatch(commitHuman(human));
    addHumans([human.id], circleId);
    if (human.isNew) {
      window.plausible && window.plausible("HumanAdded");
    }
  };

  const onRemove = (circleId) => {
    removeHuman(human.id, circleId);
  };

  const createNewCircle = (circleName) => {
    let res = createCircle(circleName);
    onAdd(res.payload.id, false);
    setQuery("");
  };

  return (
    <Modal focusElement={searchInputRef} isOpened={true} onClose={onClosed}>
      <ModalTitle>{`Edit ${human.name}'s circles`}</ModalTitle>
      <ModalBody>
        <Input
          innerRef={searchInputRef}
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          tabIndex="-1"
          autoFocus
          className="h-10  py-1 w-full mb-2"
          placeholder="Search"
        />
        {_isEmpty(visibleCircles) && !_isEmpty(query) && (
          <div className="text-sky-600">
            <span
              onClick={() => {
                createNewCircle(query);
              }}
              className="underline cursor-pointer hover:text-sky-400"
            >
              Create the circle "{query}" and add "{human.name}"
            </span>
          </div>
        )}
        <div className="h-56 overflow-auto px-3">
          {visibleCircles.map((c) => (
            <div className="mt-5" key={c.id}>
              <div className="flex">
                <div className="mr-auto">{c.name}</div>
                <>
                  {!_includes(c.humanIds, human.id) ? (
                    <>
                      <Button onClick={() => onAdd(c.id)}>Add</Button>
                    </>
                  ) : (
                    <>
                      <Button intent="danger" onClick={() => onRemove(c.id)}>
                        Remove
                      </Button>
                    </>
                  )}
                </>
              </div>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
});

EditHumanCirclesModal.displayName = "EditHumanCirclesModal";
EditHumanCirclesModal.propTypes = {
  human: PropTypes.object,
  circles: PropTypes.array,
  onClick: PropTypes.func,
  onClosed: PropTypes.func,
  addHumans: PropTypes.func,
  removeHuman: PropTypes.func,
  createCircle: PropTypes.func,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditHumanCirclesModal);
